export enum ViewStatus {
  Paused = 'paused',
  Cancelled = 'cancelled',
  Completed = 'completed',
  White = 'white',
  Pending = 'pending',
  Live = 'live',
  Draft = 'draft',
}
